module.exports = __webpack_public_path__ + "static/media/BESTS_grey.5d3686a0.webp";